<router-outlet></router-outlet>
<busy-overlay></busy-overlay>
